<template>
    <div class="row gx-3 ms-2 my-1">
        <span class="small text-body-secondary col-auto"> {{ signatoryStatus.Tag }}: {{ signatoryStatus.Email }} </span>
        <span
            v-bind:class="signatoryStatus.IsReady ? 'text-bubble-success' : ' text-bubble-warning'"
            class="col-auto small">
            {{ signatoryStatus.Status }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            signatoryStatus: { type: Object, required: true, default: null }
        }
    };
</script>
